import { createContext, RefObject } from 'react';

const PreviousRouteContext = createContext<RefObject<string | null> | null>(null);

export default PreviousRouteContext;
